<template>
  <div class="new-employee-header">
    <span class="title"> {{ $t('employee.management') }} </span>
    <v-btn v-if='displayAddEmployee' class="new-employee-button" color="primary" @click="newEmployeeClicked">
      {{ $t('service.provider.configuration.header.add.new.employee') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ServiceProviderConfigurationHeader',
  props: {
    displayAddEmployee: Boolean,
  },
  methods: {
    newEmployeeClicked() {
      this.$emit('newEmployeeClicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.new-employee-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 86px 20px 32px;

  .title {
    color: #b9c6d1;
    font-size: 20px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 24px;
  }
}
</style>
